<template>
    <Head title="Fale Conosco" />
        <PagesLayout>
        <HeaderComponent />
        <Heading title="Fale Conosco" class="xl:px-[220px] xl:pt-6 sm:pl-6 sm:pt-6"/>
        <div class="component-background-desktop h-[80vh] sm:h-[150vh]">
            <div class="p-4 xl:px-[16vw]">
                <button @click="goBack" :class="stateBack" class="back-sm hover:text-blue-600 hover:underline text-blue-300">Voltar</button>
            </div>
            <section class="xl:flex gap-14 py-6 xl:px-[16vw] xl:pt-18 xl:pb-18 px-5" >
                <div class="flex flex-col xl:gap-y-14">
                    <div class="bg-white max-w-[451px] xl:min-h-[210px] rounded-2xl border border-primary mb-5 xl:mb-0">
                        <div class="flex flex-col justify-between h-full xl:px-8 xl:pt-[18px] xl:pb-6 p-4 text-left">
                            <div class="flex flex-col justify-between items-start mb-4">
                                <p class="text-[24px] font-bold text-primary">Perguntas Frequentes</p>
                                <p class="text-[12px]">Tire suas dúvidas de forma rápida.</p>
                        </div>
                            <a href="/faq" class="sm:max-w-[212px] xl:max-h-[42px] xl:max-w-[192px] whitespace-nowrap flex justify-between items-center p-4 xl:p-2.5 w-full border border-primary hover:border-gray-300 rounded-2xl hover:bg-gray-300">
                                <p class="text-[16px] text-primary font-bold">Acessar Perguntas</p>
                                <Icon name="LinkExterno" class="w-4 h-4"/>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="flex flex-col xl:gap-y-14">
                    <div class="bg-white max-w-[451px] xl:min-h-[210px] rounded-2xl border border-primary mb-5 xl:mb-0">
                        <div class="flex flex-col xl:gap-y-16 justify-between xl:px-8 xl:pt-[18px] xl:pb-6 p-4 text-left">
                                <div class="flex flex-col gap-y-2 items-start">
                                    <p class="text-[24px] font-bold text-primary">Ligação</p>
                                    <p class="text-[14px]">Problemas ao acessar? Fale Conosco!</p>
                                    <p class="text-[14px] text-primary font-bold">0800 750 5548</p>
                                    <p class="text-[14px]">Atendimento disponível de segunda a sexta, das 10h às 17h (horário de Brasília).</p>
                                </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        </PagesLayout>
</template>
<script>
import { Head } from '@inertiajs/inertia-vue3';
import Heading from "@/Components/UI/Texts/Heading.vue";
import Icon from '@/Components/UI/Icons/Icon.vue';
import PagesLayout from "@/Layouts/Pages.vue";

export default {
  components: {
    Head,
    Heading,
    Icon,
    PagesLayout
  },
  methods: {
    goBack(){
        return window.history.go(-1);
    },
  },
};
</script>
